module.exports = __webpack_public_path__ + "img/bulgaria.b76ec474.svg";